import { useTranslate } from '@tolgee/react';
import Map from '@amf/shared/components/utils/Map';
import Button from '@amf/shared/components/button/Button';

interface TournamentMapProps {
  title: string;
  description: string;
  lat: number;
  lng: number;
}

export default function TournamentMap({ lat, lng, title, description }: TournamentMapProps) {
  const { t } = useTranslate('malyfotbal');
  return (
    <div className='TournamentMap__container'>
      <h2>
        {title}: {description}
      </h2>
      <div className='TournamentMap'>
        <div className='TournamentMap__inner'>
          <Map title={title} lat={lng} lng={lat} zoom={14} width={'100%'} height={'100%'} />
        </div>
        <div className='TournamentMap__button'>
          <a
            href={`https://mapy.cz/zakladni?source=coor&id=${lng}%2C${lat}`}
            target='_blank'
            rel='noreferrer'
          >
            <Button variant='blue-outline'>{t('tournaments.detail.location.link')}</Button>
          </a>
        </div>
      </div>
    </div>
  );
}
